import { useNavigate, useParams } from 'react-router-dom';
import './oildetail.css';

const vathalData = {
  sundakkaivathal: {
    name: 'Sundakkai Vathal',
    image: '/images/sundry/sundakkai.webp',
    description:
      'Sundakkai Vathal (சுண்டைக்காய் வத்தல்), or Dried Turkey Berry, is made by soaking fresh sundakkai in buttermilk and sun-drying it over several days—a method practiced in southern Tamil Nadu, especially in Madurai, Tirunelveli, and Dindigul. In Tamil homes, it is roasted or fried and added to vatha kuzhambu, kara kulambu, or served as a side with curd rice. Sundakkai is believed to kill intestinal worms, aid digestion, and purify blood. Rich in iron and antioxidants, Sundakkai Vathal is a time-tested ingredient in both Tamil cooking and traditional medicine.',
  },
  manathakalivathal: {
    name: 'Manathakkali Vathal',
    image: '/images/sundry/manathakalivathal.webp',
    description:
      'Manathakkali Vathal (மணத்தக்காளி வத்தல்), or Dried Black Nightshade Berries, is made by sun-drying manathakkali berries, traditionally grown in Madurai, Tirunelveli, and Sivagangai. These berries are often soaked in buttermilk before drying to reduce bitterness and enhance medicinal value. In Tamil households, they are fried and added to vatha kuzhambu, or served as a side with rasam or curd rice. Manathakkali is deeply valued in Tamil Siddha medicine for its ability to soothe ulcers, heal mouth sores, and cool the body. It is also believed to strengthen the liver and aid in gastric relief, making it a powerful addition to everyday Tamil cooking.',
  },
  brinjalvathal: {
    name: 'Brinjal Vathal',
    image: '/images/sundry/brinjal.webp',
    description:
      'Brinjal Vathal (கத்தரிக்காய் வத்தல்) is made by slicing tender brinjals (eggplants), soaking them in salted buttermilk, and sun-drying them until crisp—a method followed in rural Tamil Nadu, especially in regions like Madurai, Dindigul, and Salem. These sun-dried slices are deep-fried and added to kuzhambu, poriyal, or served as a crispy side with curd rice or rasam. Tamil families believe brinjal vathal aids digestion, improves appetite, and adds natural warmth to meals. Preserved using traditional methods, it reflects the resourcefulness and flavor heritage of Tamil cuisine.',
  },
  onionvathal: {
    name: 'Onion Vathal',
    image: '/images/sundry/onionvathal.webp',
    description:
      'Onion Vathal (வெங்காய வத்தல்) is made by soaking shallots or pearl onions in spiced buttermilk and sun-drying them for several days—a practice rooted in villages of Thanjavur, Dindigul, and Madurai. This age-old preservation method ensures year-round access to the rich flavor of onions. In Tamil kitchens, onion vathal is fried and used in vatha kuzhambu, poriyal, or as a crispy side dish. It is believed to help stimulate digestion, warm the body, and enhance the taste of simple meals. Onion Vathal brings a bold, nostalgic flavor that reflects the depth of Tamil home cooking traditions.',
  },
  midhukuvathal: {
    name: 'Midhuku Vathal',
    image: '/images/sundry/midhuku.webp',
    description:
      'Midhuku Vathal (மிடுக்கு வத்தல்) is a unique, sun-dried delicacy made from green chillies soaked in sour buttermilk and salt, traditionally prepared in southern Tamil Nadu, especially in Madurai, Dindigul, and Theni. The name "Midhuku" refers to the crunchy bite it gives when fried. These vathals are deep-fried and served as a spicy side dish, typically with curd rice or sambar sadam. Tamil people believe Midhuku Vathal aids digestion, adds a natural body heat, and brings a fiery, satisfying crunch to meals. A favorite during summer months, it’s a symbol of Tamil culinary creativity and preservation wisdom.',
  },
  kothavarangaivathal: {
    name: 'Kothavarangai Vathal',
    image: '/images/sundry/kothavarangai.webp',
    description:
      'Kothavarangai Vathal (கொத்தவரங்காய் வத்தல்), or Dried Cluster Beans, is made by sun-drying tender cluster beans that are soaked in salted buttermilk, a common summer practice in southern Tamil Nadu, especially in regions like Madurai, Dindigul, and Sivagangai. These vathals are deep-fried and served with curd rice, rasam, or added to vatha kuzhambu. Tamil families value kothavarangai for its ability to reduce body heat, improve digestion, and lower blood sugar. Preserving the natural bitterness and crunch, this vathal is a perfect blend of flavor and traditional nutrition in Tamil cuisine.',
  },
  buttermilkchilli: {
    name: 'Buttermilk Chilli',
    image: '/images/sundry/buttermilkchilli.webp',
    description:
      'Buttermilk Chilli, known as Mor Milagai (மோர் மிளகாய்) in Tamil, is made by soaking green chillies in salted buttermilk for several days and then sun-drying them—a traditional summer practice in Tamil Nadu, especially in Tirunelveli, Madurai, and Thanjavur regions. Once dried, these chillies are deep-fried and served as a spicy side with curd rice or porridge. Tamil people believe mor milagai stimulates appetite, aids digestion, and adds a warm, fiery touch to simple meals. It’s a nostalgic and essential condiment in many Tamil vegetarian homes, especially during hot seasons.',
  },
};



const VathalDetail = () => {
  const { type } = useParams();
  const vathal = vathalData[type];
  const navigate = useNavigate();
  const goToProducts = () => {
        navigate('/sundry');
    };

  if (!vathal) return <h2>Vathal product not found</h2>;

  return (
    <section
      className="sesame-section"
      style={{ backgroundImage: `url(${vathal.image})` }}
    >
      <div className="sesame-content">
        <div className="text-content">
          <button className='back-btn-viewmore' onClick={goToProducts}>⟵ Back to Dryrice Products</button>
          <h2>{vathal.name}</h2>
          <p>{vathal.description}</p>
        </div>
        <div className="button-box">
          <button className="enquire-btn">ENQUIRE NOW</button>
        </div>
      </div>
    </section>
  );
};

export default VathalDetail;
